var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"im-sidebar__customer",on:{"click":_vm.showAi}},[_c('img',{staticStyle:{"margin-top":"16px"},attrs:{"src":(_vm.staticBaseUrl + "ufd/407a24/pc/svg/ai.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }